import React from 'react';
import Content from './content';
import styled from 'styled-components';
import { minWidth } from '../variables';

const Figure = styled.figure`
    grid-column: 1 / -1;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: subgrid;
    align-items: start;

    @media (min-width: ${minWidth}px) {
        grid-column: 4 / -1;
    }
`;
const FigImage = styled.img`
    display: block;
    width: 100%;
    height: auto;
    grid-column: 1 / -1;
    margin-bottom: 4vh;
    background-color: #f7f7f8;

    @media (min-width: ${minWidth}px) {
        grid-column: 1 / -3;
    }
`;
const FigCaption = styled(Content)`
    grid-column: 1 / -1;

    @media (min-width: ${minWidth}px) {
        position: sticky;
        top: 2vh;
        align-items: start;
        grid-column: -3 / -2;
    }
`;

const Image = ({ alt, src }) => {
    return (
        <Figure>
            <FigImage loading="lazy" src={src} alt={alt} />
            <FigCaption tag="figcaption" kind="p3">
                {alt}
            </FigCaption>
        </Figure>
    );
};

export default Image;
